import { render, staticRenderFns } from "./DialogFinish.vue?vue&type=template&id=6f2bda44"
import script from "./DialogFinish.vue?vue&type=script&lang=js"
export * from "./DialogFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports